export default {
  nome: "Grupo",
  faixas: [
    {
      label: "00 a 18",
      slug: "00-18",
      value: null
    },
    {
      label: "19 a 23",
      slug: "19-23",
      value: null
    },
    {
      label: "24 a 28",
      slug: "24-28",
      value: null
    },
    {
      label: "29 a 33",
      slug: "29-33",
      value: null
    },
    {
      label: "34 a 38",
      slug: "34-38",
      value: null
    },
    {
      label: "39 a 43",
      slug: "39-43",
      value: null
    },
    {
      label: "44 a 48",
      slug: "44-48",
      value: null
    },
    {
      label: "49 a 53",
      slug: "49-53",
      value: null
    },
    {
      label: "54 a 58",
      slug: "54-58",
      value: null
    },
    {
      label: "59+",
      slug: "59-99",
      value: null
    }
  ],
  vidas: 0,
  operadoras: [],
  redes: [],
  regioes: [],
};
